import { TypedUseSelectorHook, useDispatch as useDispatchHook, useSelector as useSelectorHook } from 'react-redux';

import type { RootState, AppDispatch } from './store';

export const useSelector: TypedUseSelectorHook<RootState> = useSelectorHook;
export const useDispatch = () => useDispatchHook<AppDispatch>();